import React from "react";

interface ImageModalProps {
  isOpen: boolean;
  imageSrc: string;
  label?: string;
  onClose: () => void;
}

const ImageModal: React.FC<ImageModalProps> = ({
  isOpen,
  imageSrc,
  label,
  onClose,
}) => {
  if (!isOpen) return null;

  return (
    <div
      style={{ marginTop: "0px" }}
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm"
      onClick={onClose}
    >
      <div
        className="relative bg-white p-4 rounded-lg shadow-lg"
        onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside the modal
      >
        <img src={imageSrc} alt="Preview" className="max-w-full max-h-[80vh]" />
        <div className="flex justify-between items-center">
          <p className="text-center text-gray-800 mt-2">{label}</p>
          <button
            className="mt-2 px-2 py-1 rounded bg-gray-200 hover:bg-gray-300 text-gray-800"
            onClick={onClose}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ImageModal;
